import { z } from "zod";
import { runResultSchema } from "./contracts.js";

export const contractHistoryQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(50).default(20),
  cursor: z.string().regex(/^[A-Za-z0-9_-]+$/).max(512).optional(),
}).strict();
export const contractHistoryEntrySchema = z.object({
  completedAt: z.number().int().min(0).max(Number.MAX_SAFE_INTEGER).nullable(),
  result: runResultSchema,
}).strict();
export const contractHistorySchema = z.object({
  entries: z.array(contractHistoryEntrySchema).max(50),
  nextCursor: z.string().nullable(),
}).strict();
export type ContractHistory = z.infer<typeof contractHistorySchema>;
export type ContractHistoryQuery = z.infer<typeof contractHistoryQuerySchema>;
